import { render } from "./itax_manage.vue?vue&type=template&id=533b5353&scoped=true"
import script from "./itax_manage.vue?vue&type=script&lang=js"
export * from "./itax_manage.vue?vue&type=script&lang=js"

import "./itax_manage.vue?vue&type=style&index=0&id=533b5353&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-533b5353"]])

export default __exports__